import { useQuery } from "@tanstack/react-query";
import { getArtistDetailData } from "../api/artistApi";
import { artistKeys } from "../artistKeys";

const ONE_HOUR = 60 * 60 * 1000;
const TWELVE_HOURS = 12 * ONE_HOUR;
const TWENTY_FOUR_HOURS = 24 * ONE_HOUR;

/**
 * Hook to fetch artist rights data.
 * Uses long-lived cache and relies on manual invalidation for normal refreshes.
 * @param {number} artistId
 * @returns {import("@tanstack/react-query").UseQueryResult}
 */
export const useArtistRechteData = (artistId) => {
    return useQuery({
        queryKey: artistKeys.rechteData(artistId),
        queryFn: () => getArtistDetailData({ artistId, segments: "base,rechte" }),
        enabled: Boolean(artistId),
        staleTime: TWELVE_HOURS,
        gcTime: TWENTY_FOUR_HOURS,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
    });
};

